import { CommonModule } from '@angular/common';
import { Component, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-search-form',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatExpansionModule,
  ],
  templateUrl: './search-form.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./search-form.scss'],
})
export class SearchForm {
  formGroup = input.required<FormGroup>();
  searchClicked = output<void>();
  readonly panelOpenState = signal(false);

  get fieldsProvided(): number {
    const values = this.formGroup().value;
    if (!values) {
      return 0;
    }
    return Object.values(values).filter((value) => value !== null && value !== '').length;
  }
  onSearchClick($event: Event): void {
    $event.stopPropagation();
    this.searchClicked.emit();
  }

  onResetClick($event: Event): void {
    $event.stopPropagation();
    this.formGroup().reset();
    this.searchClicked.emit();
  }
}
